/**
 * removed all tags from a string
 *
 * @param str
 * @returns {string}
 */
export const stripTags = (str = "") => str.replace(/(<([^>]+)>)/gi, "");
